import { useConversationsHomeItem } from 'chat/conversations/tile_content'
import { MonthlySummaryDescriptionItemContent } from 'home/monthly_summary/descriptive_tile_content'
import { MonthlySummaryItemContent } from 'home/monthly_summary/tile_content'
import {
  ContentComponentMap,
  HomeItem,
  HomeTileItem,
  HomeTileItems,
} from 'home/types'
import { useNotificationsSummaryHomeItem } from 'notifications/queries/list'
import { useOpenShiftsHomeItem } from 'open_shifts/queries/summary'
import { useTimeOffRequestsHomeItem } from 'request_time_off/queries/list'
import { useHelperScheduleHomeItem } from 'schedule/queries/list'
import { useUser } from 'users/queries/detail'
import { useDailyPayHomeItem } from './daily_pay/queries/list'
import { useMonthlySummaryHomeItem } from './monthly_summary/queries/list'
import { useUpdateAppHomeItem } from './update_app'

const homeTileItems: HomeTileItem[] = [
  'helperSchedule',
  'notifications',
  'dailyPayPromotion',
  'openShifts',
  'monthlyProgress',
  'conversations',
  'timeOffRequests',
  'updateApp',
]

const atcHomeTileItems: HomeTileItem[] = [
  'openShifts',
  'notifications',
  'dailyPayPromotion',
  'helperSchedule',
  'monthlyProgress',
  'conversations',
  'timeOffRequests',
  'updateApp',
]

export function useHomeTilesData(): HomeItem[] {
  const { data: user } = useUser()

  const homeItems: HomeTileItems = {
    helperSchedule: useHelperScheduleHomeItem(),
    dailyPayPromotion: useDailyPayHomeItem(),
    notifications: useNotificationsSummaryHomeItem(),
    openShifts: useOpenShiftsHomeItem(),
    monthlyProgress: useMonthlySummaryHomeItem(),
    conversations: useConversationsHomeItem(),
    timeOffRequests: useTimeOffRequestsHomeItem(),
    updateApp: useUpdateAppHomeItem(),
  }
  const keys = user?.isAtc ? atcHomeTileItems : homeTileItems

  return keys.flatMap(key => (key in homeItems ? homeItems[key] ?? [] : []))
}

export const contentComponentMap: ContentComponentMap = {
  MONTHLY_SUMMARY_ITEM_CONTENT: MonthlySummaryItemContent,
  MONTHLY_SUMMARY_DESCRIPTION_ITEM_CONTENT:
    MonthlySummaryDescriptionItemContent,
}
